import { z } from "zod";
import { FLAG_CONDITION_CMP_VALUES, FLAG_EFFECT_OP_VALUES, FLAG_TYPE_VALUES, FlagType } from "../../constants/flag.js";
import { FLAG_NAME_MAX_LENGTH } from "../../constants/limits.js";
export const FlagValueSchema = z.union([z.boolean(), z.number()]);
export const FlagEffectSchema = z.object({
    flag: z.string().min(1).max(FLAG_NAME_MAX_LENGTH),
    op: z.enum(FLAG_EFFECT_OP_VALUES),
    value: FlagValueSchema,
});
export const FlagConditionSchema = z.object({
    flag: z.string().min(1).max(FLAG_NAME_MAX_LENGTH),
    cmp: z.enum(FLAG_CONDITION_CMP_VALUES),
    value: FlagValueSchema,
});
export const StoryFlagDefSchema = z
    .object({
    name: z.string().min(1).max(FLAG_NAME_MAX_LENGTH),
    type: z.enum(FLAG_TYPE_VALUES),
    initialValue: FlagValueSchema,
})
    .refine((flag) => (flag.type === FlagType.BOOLEAN ? typeof flag.initialValue === "boolean" : typeof flag.initialValue === "number"), "initialValue doit correspondre au type du flag");
export const FlagStateSchema = z.record(z.string(), FlagValueSchema);
